import Validation from '../models/Validation';
import FormValidation from '../models/FormValidation';
import Constraint from '../models/Constraint';
import { isValidNumber as _isValidPhoneNumber } from 'libphonenumber-js';

const notNullNotUndefined = (value) => {
  return value !== null && value !== void 0;
}
const singleOneDigitNumber = (value) => {
  value = String(value);
  let number = parseInt(value);
  return (String(number) === value && singleDigit.test(value));
}
const isValidPhoneNumber = (value) => {
  const validUS = _isValidPhoneNumber(value, "US");
  const validCA = _isValidPhoneNumber(value, "CA");
  return validUS || validCA;
}
const hasThreeCommaParts = (value) => {
  return value && value.split(",").length === 3;
}
const singleDigit = /\b\d\b/;
const numbersOnly = /^[0-9]*$/;
const hasAtLeastOneDigit = /(?=.*?[0-9])/;
const hasAtLeastOneUpperCaseAlphabet = /(?=.*?[A-Z])/;
const hasAtLeastOneLowerCaseAlphabet = /(?=.*?[a-z])/;
const hasAtLeastOneSpecialChar = /(?=.*?[#?!@$%^&*-])/;
const isValidEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function makeDummyContraint() {
  return new Constraint("Dummy", (bool) => bool);
}
const makeLengthRangeTest = (min = 3, max = 20, unit = "digits") => {
  const rule = (value) => {
    const len = String(value).length;
    return len >= min && len <= max;
  };
  return new Constraint(`${min} to ${max} ${unit}`, rule);
}
const makeMinLengthTest = (min = 4, unit = "digits") => {
  const rule = (value) => {
    return String(value).length >= min
  }
  return new Constraint(`At least ${min} ${unit}`, rule);
}
const makeMaxLengthTest = (max = 1, unit = "digits") => {
  const rule = (value) => {
    return String(value).length <= max
  }
  return new Constraint(`At least ${max} ${unit}`, rule);
}

// Validations
function EmailValidation() {
  return new Validation([
    new Constraint("Is valid email", isValidEmail),
  ]);
}
function PasswordValidation() {
  return new Validation([
      new Constraint("One lower case alphabet", hasAtLeastOneLowerCaseAlphabet),
      new Constraint("One upper case alphabet", hasAtLeastOneUpperCaseAlphabet),
      new Constraint("One digit", hasAtLeastOneDigit),
      new Constraint("One special character", hasAtLeastOneSpecialChar),
      makeMinLengthTest(8, "characters"),
    ]
  );
}
function NmaeValidation() {
  return new Validation([
      makeLengthRangeTest(3, 20, "characters"),
    ]
  );
}
function DoorOpenNumberValidation() {
  return new Validation([
      new Constraint("Single one digit number", singleOneDigitNumber),
    ]
  );
}
function AddressValidation() {
  return new Validation([
      new Constraint("Is valid address", hasThreeCommaParts),
    ]
  );
}
function PhoneNumberValidation() {
  return new Validation([
      new Constraint("Is valid phone number", isValidPhoneNumber),
    ]
  );
}
function PasscodeValidation() {
  return new Validation([
    new Constraint("Numbers only", numbersOnly),
    makeLengthRangeTest(4, 6, "digits"),
  ]);
}
function WellDefinedValidation() {
  return new Validation([
    new Constraint("Value selected", notNullNotUndefined),
  ]);
}

// Form validations
function SignupFormValidation() {
  return new FormValidation({
    email: new EmailValidation(),
    password: new PasswordValidation(),
    phone: new PhoneNumberValidation(),
  })
}
function PropertyFormValidation() {
  return new FormValidation({
    name: new NmaeValidation(),
    doorOpenNumber: new DoorOpenNumberValidation(),
    address: new AddressValidation(),
  });
}
function PasscodeFormValidation() {
  return new FormValidation({
    name: new NmaeValidation(),
    passcode: new PasscodeValidation(),
  });
}
function UserInfoFormValidation() {
  return new FormValidation({
    name: new NmaeValidation(),
    phone: new PhoneNumberValidation(),
  })
}

export {
  EmailValidation,
  PasswordValidation,
  DoorOpenNumberValidation,
  NmaeValidation,
  AddressValidation,
  PhoneNumberValidation,
  // form validations
  SignupFormValidation,
  PropertyFormValidation,
  PasscodeFormValidation,
  UserInfoFormValidation
}


// WEBPACK FOOTER //
// ./src/tools/Validations.js